import { AlertCircle, CheckCircle2, Circle, Loader2, RefreshCw, Upload } from 'lucide-react';
import { canRecheckModelArkAsset, canRegisterModelArkAsset, getModelArkReferenceState } from '../../utils/modelArkAssets';
import './ModelArkReferenceStatus.css';

const STATUS_LABELS = {
  Active: '已入库', NotRegistered: '未入库', Pending: '排队入库', Processing: '入库中',
  Failed: '入库失败', Unknown: '待核查', Unavailable: '库未配置',
  Loading: '检测中', ReadError: '检测失败', MissingOriginal: '缺少原图',
};

export function ModelArkReferenceStatus({ registry, item, disabled = false, label = '参考图' }) {
  if (!registry.active) return null;
  const { reference, record, status, libraryLabel } = getModelArkReferenceState(registry, item);
  const pending = status === 'Pending' || status === 'Processing' || status === 'Loading';
  const Icon = status === 'Active' ? CheckCircle2 : pending ? Loader2
    : ['Failed', 'Unknown', 'ReadError', 'Unavailable', 'MissingOriginal'].includes(status) ? AlertCircle : Circle;
  const canRegister = canRegisterModelArkAsset(status, true);
  const canRecheck = status === 'Unknown' && canRecheckModelArkAsset(record);
  const action = canRegister ? (status === 'Failed' ? '重试入库' : '入库')
    : canRecheck ? '重新查询' : status === 'ReadError' ? '重新检测' : '';
  const detail = registry.error || record?.error || registry.targetConfiguration?.error
    || (status === 'Unknown' ? '登记结果待核查；不会重复创建。没有可查询的素材 ID 时请联系管理员。'
      : status === 'MissingOriginal' ? '请重新选择带原始图片或媒体 URL 的参考素材。'
        : '按当前所选模型的素材库登记状态显示，不代表视频生成权限已核验。');
  return <div className="modelark-reference-status" data-status={status || 'Unknown'}>
    <span className="modelark-reference-status__label" title={`${libraryLabel}：${detail}`}>
      <Icon size={11} aria-hidden="true" className={pending ? 'animate-spin' : ''} />
      <span>{libraryLabel} · {STATUS_LABELS[status] || '待核查'}</span>
    </span>
    {action && <button
      type="button"
      aria-label={`${label} · ${libraryLabel} · ${action}`}
      disabled={disabled || registry.loading || registry.submitting || ((canRegister || canRecheck) && registry.targetConfiguration?.configured !== true)}
      title={canRecheck ? '仅重新查询已有素材，不重复创建' : `${action} · ${libraryLabel}`}
      onClick={(event) => {
        event.stopPropagation();
        if (canRegister) void registry.register([reference], { retryFailed: status === 'Failed' });
        else if (canRecheck) void registry.recheck([reference]);
        else registry.refresh();
      }}
    >
      {canRegister ? <Upload size={11} aria-hidden="true" /> : <RefreshCw size={11} aria-hidden="true" />}
      {action}
    </button>}
  </div>;
}
